const STEPS = [
  {
    n: "01",
    title: "Określ cel i poziom",
    desc: "3-minutowy onboarding: po co Ci język, ile czasu masz tygodniowo, co już umiesz. Test poziomujący A1–C2.",
  },
  {
    n: "02",
    title: "Ćwicz codziennie z AI",
    desc: "Krótkie 10-minutowe sesje z Arthurem — konwersacja, korekta wymowy, nowe słowa w kontekście Twoich zainteresowań.",
  },
  {
    n: "03",
    title: "Lekcja z lektorem co tydzień",
    desc: "Co tydzień 50-minutowa lekcja video. Lektor widzi Twój raport z AI — wie dokładnie, nad czym pracujecie.",
  },
];

export function HowItWorks(): JSX.Element {
  return (
    <section id="how" className="py-20 md:py-28 bg-ink-800/40 border-y border-ink-700">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-14 max-w-2xl mx-auto">
          <div className="text-xs text-lime-500 uppercase tracking-widest font-semibold mb-3">Jak to działa</div>
          <h2 className="text-3xl md:text-5xl font-bold text-white tracking-tight">
            Od zera do rozmowy w <span className="text-lime-500">3 krokach</span>
          </h2>
        </div>
        <div className="grid md:grid-cols-3 gap-8 relative">
          <div className="hidden md:block absolute top-12 left-[16%] right-[16%] h-px bg-gradient-to-r from-transparent via-lime-500/30 to-transparent" />
          {STEPS.map((s) => (
            <div key={s.n} className="text-center relative">
              <div className="relative inline-flex items-center justify-center w-24 h-24 rounded-full bg-ink-900 border border-lime-500/40 mb-5">
                <span className="text-2xl font-bold text-lime-500">{s.n}</span>
                <div className="absolute inset-0 rounded-full bg-lime-500/10 blur-xl -z-10" />
              </div>
              <h3 className="text-xl font-bold text-white mb-3">{s.title}</h3>
              <p className="text-ink-300 text-sm leading-relaxed max-w-xs mx-auto">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
